module.exports = __webpack_public_path__ + "static/media/reset-password-icon.7bbb5014.svg";